import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_WIDTH, STORAGE_KEYS } from "../constants";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutModal from "../Modals/logOut";
import useAuth from "../hooks/useAuth";
import { usePostLogoutMutation } from "../service/auth";
import { USER } from "../types/User";
import secureLocalStorage from "react-secure-storage";
import { removeFromStorage } from "../helpers";
import { setCredentials } from "../reducers/authSlice";
import { showError, showToast } from "../constants/toasts";
import { useAppDispatch } from "../hooks/store";

interface Props {
  handleSidebarToggle: () => void;
}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const [scroll, setScroll] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openLogout, setOpenLogout] = useState<boolean>(false);

  const user = useAuth() as USER;
  const [logoutMethod] = usePostLogoutMutation();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const handleLogout = async () => {
    try {
      const res = await logoutMethod({}).unwrap();
      if (res.code === 200) {
        // if (true) {
        showToast("Log-out successfully");
        secureLocalStorage.removeItem("permissions");
        secureLocalStorage.removeItem("role");
        secureLocalStorage.removeItem("user");
        removeFromStorage(STORAGE_KEYS.token);
        removeFromStorage(STORAGE_KEYS.tempToken);
        dispatch(
          setCredentials({
            user: null,
            token: null,
          })
        );
        navigate("/");
        // }
      }
    } catch (error: any) {
      console.log("error :", error);
      showError(error?.data?.message);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);

  return (
    <Box className="site_header">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div className="topbar_left">
            <IconButton onClick={handleSidebarToggle}>
              <MenuIcon />
            </IconButton>
          </div>
          <div className="topbar_right">
            <Box>
              <IconButton
                className="icon_btn"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={() => navigate("/recieved-notifications")}
                // onClick={handleClick1}
              >
                <NotificationsActiveIcon />
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="noti_head">
                  <Typography component="h2">Notifications</Typography>
                  <Button
                    className="btn btn_primary sm"
                    onClick={() => {
                      navigate("/recieved-notifications");
                      handleClose1();
                    }}
                  >
                    See All
                  </Button>
                </Box>
                <ul className="noti_list">
                  <li>
                    <figure>
                      <img
                        src={
                          user?.image || "/static/images/user_placeholder.png"
                        }
                        alt=""
                      />
                    </figure>
                    <div className="noti_info">
                      <Typography component="h3">
                        Emma Smith
                        <Typography component="span">1 Day ago</Typography>
                      </Typography>
                      <Typography component="p">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit
                        dolor sit amet consectetur.
                      </Typography>
                    </div>
                  </li>
                  <li>
                    <figure>
                      <img src="/static/images/user_placeholder.png" alt="" />
                    </figure>
                    <div className="noti_info">
                      <Typography component="h3">
                        Emma Smith
                        <Typography component="span">1 Day ago</Typography>
                      </Typography>
                      <Typography component="p">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit
                        dolor sit amet consectetur.
                      </Typography>
                    </div>
                  </li>
                  <li>
                    <figure>
                      <img src="/static/images/user_placeholder.png" alt="" />
                    </figure>
                    <div className="noti_info">
                      <Typography component="h3">
                        Emma Smith
                        <Typography component="span">1 Day ago</Typography>
                      </Typography>
                      <Typography component="p">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit
                        dolor sit amet consectetur.
                      </Typography>
                    </div>
                  </li>
                </ul>
              </Menu>
            </Box>

            <Box>
              <IconButton
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img
                  src={user?.image || "/static/images/admin_icon.png"}
                  alt=""
                />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    navigate("/manage-profile");
                    handleClose();
                  }}
                >
                  <PersonIcon /> My Profile
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate("/manage-profile/change-password");
                    handleClose();
                  }}
                >
                  <LockIcon /> Change Password
                </MenuItem>
                <MenuItem onClick={() => setOpenLogout(true)}>
                  <LogoutIcon /> Logout
                </MenuItem>
              </Menu>
            </Box>
          </div>
        </Toolbar>
      </AppBar>
      <LogoutModal
        openLogout={openLogout}
        setOpenLogout={setOpenLogout}
        handleLogout={handleLogout}
      />
    </Box>
  );
}

export default Topbar;
